import { ClimatisationInfo } from "./climatisation";
import { ElectricityInfoDto } from "./electricity";

export enum MeterType {
    DIGITAL = "Digitaal",
    ANALOG = "Analoog",
    // ... add other types as needed ...
}


export enum DayNight {
    SINGULAR = "Enkelvoudig",
    NIGHT = "Exclusieve nachtteller",
    DAY_NIGHT = "Dag- en nacht",
    BUDGET = 'Budgetmeter'
    // ... add other types as needed ...
}

export enum MeterSubCategory {
    OFFICIAL = "Officiële meter",
    UNOFFICIAL = "Tussenmeter",
    // ... add other types as needed ...
}

export enum MeterCategory {
    GAS = "Gas",
    ELECTRICITY = "Elektriciteit",
    WATER = "Water",
    // ... add other types as needed ...
}

export enum ElectricityPhases {
    MONOFASE_1_230 = "Monofase 1x230V",
    THREE_PHASIC_3_400_N = "Driefase 3x400V+N",
    // ... add other types as needed ...
}

export type MeterDto = {
    id: number;
    category: MeterCategory;
    subCategory: MeterSubCategory;
    phases: ElectricityPhases;
    voltage: string;
    amperage: string;
    amperageFuse: string;
    meterType: MeterType;
    eanNumber?: string;
    meterNumber?: string;
    location: string;
    readings: MeterReading[];
    electricityInfo: ElectricityInfoDto;
    electricityInfoId?: number;
    climatisationInfo: ClimatisationInfo;
    climatisationInfoId?: number;
    waterUnitInfoId?: number;
    waterBuildingInfoId?: number;
}

export type MeterReading = {
    id: number;
    readingValue: number;    //value before the comma is recorded
    timestamp: Date;
    meter: MeterDto;
}